import { render, staticRenderFns } from "./DallboggSconto.vue?vue&type=template&id=6e2021bb&scoped=true"
import script from "./DallboggSconto.vue?vue&type=script&lang=js"
export * from "./DallboggSconto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2021bb",
  null
  
)

export default component.exports